angular.module('shared').factory('ConfirmLeaveUnsavedChangesService', ["$rootScope", "$window", function($rootScope, $window) {
  return {
    watch: function($scope, value, params) {
      var removePageLeaveListeners, timestamps, unsubscribeStateChangeEnd, unsubscribeStateChangeStart;
      timestamps = {
        init: moment()
      };
      $scope.$watch(value, function(val, prev) {
        if (!$scope.ignoreChangeCheck && !_.isEqual(val, prev)) {
          $scope.displayConfirmationOnClose = true;
          $rootScope.stateChangeConfirmMessage = "Are you sure? This will abandon any unsaved changes.";
          return $window.onbeforeunload = function(e) {
            e.returnValue = $rootScope.stateChangeConfirmMessage;
            return $rootScope.stateChangeConfirmMessage;
          };
        } else {
          $scope.displayConfirmationOnClose = false;
          $rootScope.stateChangeConfirmMessage = void 0;
          return $window.onbeforeunload = void 0;
        }
      }, true);
      unsubscribeStateChangeStart = $rootScope.$on('$stateChangeStart', function() {
        return timestamps.changeStart = moment();
      });
      unsubscribeStateChangeEnd = $rootScope.$on('$stateChangeSuccess', function() {
        if (!(params != null ? params.closeModal : void 0) || !timestamps.changeStart || timestamps.changeStart.diff(timestamps.init, 'seconds', true) < 0.3) {
          return;
        }
        return params != null ? params.closeModal() : void 0;
      });
      removePageLeaveListeners = function() {
        $rootScope.stateChangeConfirmMessage = void 0;
        return $window.onbeforeunload = void 0;
      };
      $scope.$on('$destroy', function() {
        if (typeof unsubscribeStateChangeStart === "function") {
          unsubscribeStateChangeStart();
        }
        unsubscribeStateChangeEnd();
        return removePageLeaveListeners();
      });
      return removePageLeaveListeners;
    }
  };
}]);
